export const STD_COV_SUBTYPES = [
  { name: "CA PFL", value: "CA PFL" },
  { name: "CA SDI", value: "CA SDI" },
  { name: "CO FAMLI", value: "CO FAMLI" },
  { name: "CT Paid Leave", value: "CT Paid Leave" },
  { name: "HI TDI", value: "HI TDI" },
  { name: "MA PFML", value: "MA PFML" },
  { name: "MD FAMLI", value: "MD FAMLI" },
  { name: "MN PFL", value: "MN PFL" },
  { name: "NH PFML", value: "NH PFML" },
  { name: "NJ FLI", value: "NJ FLI" },
  { name: "NJ TDI", value: "NJ TDI" },
  { name: "NY DBL", value: "NY DBL" },
  { name: "NY PFL", value: "NY PFL" },
  { name: "Paid Leave OR", value: "Paid Leave OR" },
  { name: "PR SINOT", value: "PR SINOT" },
  { name: "WA PFML", value: "WA PFML" },
];
